import { NJBadge } from '@engie-group/fluid-design-system-react';
import type { NJBadgeProps } from '@engie-group/fluid-design-system-react';

type BadgeVariant = NonNullable<NJBadgeProps['variant']>;

/** Canonical Nemo statuses → FDS badge variant. Extend here rather than in prototypes. */
const STATUS_VARIANT: Record<string, BadgeVariant> = {
    Succès: 'success',
    Actif: 'success',
    Terminé: 'success',
    'En cours': 'information',
    /** Import/export job running (measured on integration, `nj-badge--neutral`). */
    'En Cours': 'neutral',
    'En attente': 'neutral',
    Échec: 'danger',
    Erreur: 'danger',
    Critique: 'danger',
    Majeur: 'warning',
    Modéré: 'warning',
    Mineur: 'warning',
    Inactif: 'neutral',
    Autre: 'neutral',
    Construction: 'information',
    Archivé: 'neutral',
    Indisponible: 'danger',
};

/**
 * Status pill as rendered by Nemo (`NJBadge` subtle). Use `size="lg"` in info grids (Statut, Phase d'étude)
 * and the default `md` inside tables.
 */
export function Size2MixStatusTag({ label, variant, size = 'md' }: { label: string; variant?: BadgeVariant; size?: 'sm' | 'md' | 'lg' }) {
    return (
        <NJBadge variant={variant ?? STATUS_VARIANT[label] ?? 'neutral'} emphasis="subtle" size={size}>
            {label}
        </NJBadge>
    );
}
